export enum BookingType {
  Preliminary = 0,
  Normal = 1,
  TravelAgency = 2,
  UnConfirmedInternet = 3,
  ConfirmedInternet = 4,
  OwnerOwn = 5,
  OwnerReported = 6,
  PreliminaryGroup = 7,
  ConfirmedGroup = 8,
  UnConfirmedInternetOwnerSite = 9,
  ConfirmedInternetOwnerSite = 10,
  UnConfirmedInterhome = 11,
  ConfirmedInterhome = 12,
  TemporaryDisabled = 13,
  None = 14,
  Draft = 15,
}

export const bookingTypeTranslations = {
  en: {
    [BookingType.Preliminary]: 'Preliminary booking',
    [BookingType.Normal]: 'Normal booking',
    [BookingType.TravelAgency]: 'Travel agency booking',
    [BookingType.UnConfirmedInternet]: 'Unconfirmed Internet booking',
    [BookingType.ConfirmedInternet]: 'Confirmed internet booking',
    [BookingType.OwnerOwn]: 'Owners own booking',
    [BookingType.OwnerReported]: 'Owners reported booking',
    [BookingType.PreliminaryGroup]: 'Preliminary Group booking',
    [BookingType.ConfirmedGroup]: 'Confirmed Group booking',
    [BookingType.UnConfirmedInternetOwnerSite]:
      'Unconfirmed booking from owners site',
    [BookingType.ConfirmedInternetOwnerSite]:
      'Confirmed booking from owners site',
    [BookingType.UnConfirmedInterhome]: 'Not in Use',
    [BookingType.ConfirmedInterhome]: 'Not in Use',
    [BookingType.TemporaryDisabled]: 'Temporary disbled',
    [BookingType.Draft]: 'Draft booking',
  },
  fi: {
    [BookingType.Preliminary]: 'Alustava varaus',
    [BookingType.Normal]: 'Normaali varaus',
    [BookingType.TravelAgency]: 'Matkatoimistovaraus',
    [BookingType.UnConfirmedInternet]: 'Vahvistamaton internet varaus',
    [BookingType.ConfirmedInternet]: 'Vahvistettu internet varaus',
    [BookingType.OwnerOwn]: 'Omistajan oma varaus',
    [BookingType.OwnerReported]: 'Omistajan ilmoittama varaus',
    [BookingType.PreliminaryGroup]: 'Alustava ryhmävaraus',
    [BookingType.ConfirmedGroup]: 'Vahvistettu ryhmävaraus',
    [BookingType.UnConfirmedInternetOwnerSite]:
      'Vahvistamaton varaus omistajan kotisivuilta',
    [BookingType.ConfirmedInternetOwnerSite]:
      'Vahvistettu varaus omistajan kotisivuilta',
    [BookingType.UnConfirmedInterhome]: 'Ei käytössä',
    [BookingType.ConfirmedInterhome]: 'Ei käytössä',
    [BookingType.TemporaryDisabled]: 'Väliaikaisesti pois myynnistä',
    [BookingType.Draft]: 'Luonnos',
  },
};
